export default __webpack_public_path__ + "static/media/logout1.be09b5dd.svg";